import React, { useState } from 'react';

import { Analytics } from '@cobliteam/analytics';

import { DialogWithHeader } from '@cobliteam/base-components';

import InputModule from './components/InputModule';
import SelectIssueModule from './components/SelectIssueModule';
import { IssueOption } from './components/SelectIssueModule/SelectIssueModule';
import StartModule from './components/StartModule';

enum ModalPhase {
  START = 'START',
  SELECT_ISSUE = 'SELECT_ISSUE',
  OTHER_ISSUE = 'OTHER_ISSUE',
  EXPLAIN_ISSUE = 'EXPLAIN_ISSUE',
}

interface ReportDataProblemModalProps {
  onClose: () => void;
}

const ReportDataProblemModal = ({ onClose }: ReportDataProblemModalProps) => {
  const [modalPhase, setModalPhase] = useState<ModalPhase>(ModalPhase.START);
  const [selectedIssue, setSelectedIssue] = useState<IssueOption | undefined>(
    undefined
  );
  const [otherIssueName, setOtherIssueName] = useState<string>('');
  const [problemDescription, setProblemDescription] = useState<string>('');

  const handleStartModuleFinish = () => {
    setModalPhase(ModalPhase.SELECT_ISSUE);
  };

  const handleOtherIssueInputChange = (text: string) => {
    setOtherIssueName(text);
  };

  const handleSelectIssueFinish = (newSelectedIssue: IssueOption) => {
    setSelectedIssue(newSelectedIssue);

    if (newSelectedIssue === IssueOption.OTHER) {
      setModalPhase(ModalPhase.OTHER_ISSUE);
    } else {
      setModalPhase(ModalPhase.EXPLAIN_ISSUE);
    }
  };

  const handleProblemDescriptionChange = (text: string) => {
    setProblemDescription(text);
  };

  const handleDescribeOtherFinish = () => {
    setModalPhase(ModalPhase.EXPLAIN_ISSUE);
  };

  const handleFormSubmit = () => {
    Analytics.track('Report Data Problem Modal Submited', {
      issue: selectedIssue,
      otherIssueDescription: otherIssueName,
      feedback: problemDescription,
    });

    onClose();
  };

  const renderProperPhase = () => {
    switch (modalPhase) {
      case ModalPhase.START:
        return (
          <StartModule onClose={onClose} onContinue={handleStartModuleFinish} />
        );
      case ModalPhase.SELECT_ISSUE:
        return (
          <SelectIssueModule
            onClose={onClose}
            onContinue={handleSelectIssueFinish}
          />
        );
      case ModalPhase.OTHER_ISSUE:
        return (
          <InputModule
            onClose={onClose}
            onSubmit={handleDescribeOtherFinish}
            onInputChange={handleOtherIssueInputChange}
            inputValue={otherIssueName}
            descriptionText='Sobre qual dado gostaria de opinar*:'
            placeholderText='Ex: Velocidade da via'
            buttonText='Continuar'
          />
        );
      case ModalPhase.EXPLAIN_ISSUE:
        return (
          <InputModule
            onClose={onClose}
            onSubmit={handleFormSubmit}
            onInputChange={handleProblemDescriptionChange}
            inputValue={problemDescription}
            descriptionText='Explique detalhadamente quais problemas você encontrou com nossos dados e dê exemplos*:'
            placeholderText='Deixe sua opinião aqui'
            buttonText='Enviar'
          />
        );
    }
  };

  return (
    <DialogWithHeader
      open
      title='Enviar opinião'
      onClose={onClose}
      maxWidth='md'
    >
      {renderProperPhase()}
    </DialogWithHeader>
  );
};

export default ReportDataProblemModal;
